import { call, put, select, takeLatest } from "redux-saga/effects";
import qs from 'qs';
import { FETCH_CONTACT_CARD_REQUEST, fetchContactCardFailure, fetchContactCardSuccess } from "../../actions/opportunities/contactMapCardActions";
import iq_api_v2 from "../../../../services/iqApiV2";

async function findContactCardData(opportunityId="",userId) {
    const data = qs.stringify({
      opportunity_id: opportunityId,
      user_id:userId
    });
  
    try {
      const response = await iq_api_v2.post("/opportunities/get_contacts?"+data, '')
      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchContactCardSaga() {
  try {
    const payload = yield select(
      (state) => state?.contactCardReducer?.payload
    );
    const {opportunityId = "",userId} = payload;
    const data = yield call(
        findContactCardData,
        opportunityId,
        userId
    );
    yield put(fetchContactCardSuccess(data));
  } catch (error) {
    yield put(fetchContactCardFailure(error.message));
  }
}

// Watcher Saga
export function* watchContactCardData() {
  yield takeLatest(FETCH_CONTACT_CARD_REQUEST, fetchContactCardSaga);
}
